import { useTranslation } from 'react-i18next'
import { KebabCase } from 'type-fest'

import { SectionTab } from 'components/Tabs'
import { Workspace } from 'features/workspace'
import { MultiAnchorForm } from './Sections/MultianchorSection/Form'
import { RichPlacement1Section } from './Sections/RichPlacement1Section'
import { RichPlacement2Section } from './Sections/RichPlacement2Section'
import { RichPlacement3Section } from './Sections/RichPlacement3Section'

export type RichPlacementsUrlParams = Partial<{
  section: SectionRouteParam
  workspaceId: Workspace['id']
}>

export type SectionRouteParam = KebabCase<
  'multianchor' | 'rich-placement-1' | 'rich-placement-2' | 'rich-placement-3'
>

export const useSectionTabs = (): SectionTab<SectionRouteParam>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.sections',
  })

  return [
    {
      element: 'multianchor',
      label: t('multianchor'),
      page: <MultiAnchorForm />,
    },
    {
      disabled: true,
      element: 'rich-placement-1',
      label: t('richPlacement1'),
      page: <RichPlacement1Section />,
    },
    {
      disabled: true,
      element: 'rich-placement-2',
      label: t('richPlacement2'),
      page: <RichPlacement2Section />,
    },
    {
      disabled: true,
      element: 'rich-placement-3',
      label: t('richPlacement3'),
      page: <RichPlacement3Section />,
    },
  ]
}
